import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import "./jobcentral.css"

const PremiumHeader = () => {

const data = useStaticQuery(graphql`
  query getPremiumCount {
    allAirtable(filter: {data: {Status: {eq: "premium"}}}) {
      totalCount
    }
  }
  `
  )
  
if (data.allAirtable.totalCount > 0) {
  return (
    <h3>Featured Jobs:</h3>
        )
  } 
else 
  return (
    <span></span>
  ) 
};
  

  export default PremiumHeader;